import { render, staticRenderFns } from "./dtkzlszmx.vue?vue&type=template&id=1aa50b16&scoped=true&"
import script from "./dtkzlszmx.vue?vue&type=script&lang=js&"
export * from "./dtkzlszmx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa50b16",
  null
  
)

export default component.exports